module.exports = __webpack_public_path__ + "static/media/stage-product-icons-trunking.42c5a1ea.svg";